module.exports = __webpack_public_path__ + "fonts/3db65dc.woff";